export default __webpack_public_path__ + "images/5af919bc72eb5f67cac832061fdcbcd5-musical.webp";